import { PromoCarouselLocation } from '../types/enums';
import type { VoucherStatus } from '../types/enums';

// @TODO: Check invalidaton of PROMOTIONS_QP, seems to be in multiple places at once...
const PromotionsQueryKeys = {
  PROMOTIONS: (location: PromoCarouselLocation) => ['promotions', location],
  PROMOTIONS_QP: () => ['promotions', PromoCarouselLocation.QUICKPICKS],
  PROMOTIONS_CONTEST: () => ['promotions', PromoCarouselLocation.CONTEST],
  PROMOTIONS_CONTEST_ID: (contestId: string) => ['promotions', PromoCarouselLocation.CONTEST, contestId],
  PROMOTIONS_PROMO_CENTER: () => ['promotions', PromoCarouselLocation.PROMO_CENTER],
}

/**
 * Query key factory for voucher-related React Query operations
 * Follows the same pattern as QuickPickQueryKeys and ContestQueryKeys
 *
 * Centralizes all voucher query key generation to ensure consistency
 * and enable proper cache invalidation across the application.
 */
// @deprecated
const VoucherQueryKeys = {
  /**
   * Query key for paginated voucher queries
   * @param params - Pagination and filtering parameters
   * @returns Query key array for useQuery/useInfiniteQuery
   * @note React Query handles object destructuring automatically, so we can pass the params object directly
   */
  vouchers: (params?: { page?: number; pageSize?: number; status?: VoucherStatus }) => [
    'vouchers',
    'paginated',
    params,
  ],

  /**
   * Query key for eligible voucher queries
   * @param params - Eligibility filtering parameters
   * @returns Query key array for useQuery
   * @note React Query handles object destructuring automatically, so we can pass the params object directly
   */
  eligible: (params?: { contestId?: string; voucherType?: string; amount?: number }) => [
    'vouchers',
    'eligible',
    params,
  ],
};

/**
 * Query key factory for deposit bonus-related React Query operations
 * Follows the same pattern as VoucherQueryKeys and other query key factories
 *
 * Centralizes all deposit bonus query key generation to ensure consistency
 * and enable proper cache invalidation across the application.
 */
const DepositBonusQueryKeys = {
  /**
   * Query key for paginated assigned deposit bonus queries
   * @param params - Pagination parameters
   * @returns Query key array for useQuery
   */
  ASSIGNED: (params?: { page?: number; pageSize?: number }) => [
    'depositBonuses',
    'assigned',
    'paginated',
    params?.page,
    params?.pageSize,
  ],

  /**
   * Query key for invalidating all assigned deposit bonus queries
   * Matches all assigned bonus queries regardless of pagination params
   * @returns Query key array for invalidateQueries
   */
  ALL_ASSIGNED: () => ['depositBonuses', 'assigned'],
};

const PromoCodesQueryKeys = {
  PROMO_CODE_DETAIL: (promoCode: string) => ['promo-code', promoCode],
  PROMO_CODE_CLAIM: (promoCode: string) => ['promo-code', promoCode, 'claim'],
};


const ContestVoucherValidationQueryKey = (
  voucherId: string | undefined,
  contestId: string | undefined,
  entryAmountInDollars: number,
  league: string | undefined,
  contestType: string | undefined
) =>
  [
    'contest-voucher-validation',
    voucherId,
    contestId,
    entryAmountInDollars,
    league,
    contestType,
  ] as const;


export default VoucherQueryKeys;
export {
  DepositBonusQueryKeys,
  PromoCodesQueryKeys,
  PromotionsQueryKeys,
  ContestVoucherValidationQueryKey,
};
